import { apiGetEventSearch } from '../apiRequest/events';

const SEARCH_FIELD = {
  publishDate: 'publish_date',
};

export const EventSearch = {
  data() {
    return {
      searchOptions: {},
    };
  },
  async created() {
    Promise.all([
      this.getSearch({ params: {...this.$route.query, field: SEARCH_FIELD.publishDate}}),
    ]);
  },
  methods: {
    async getSearch(payload) {
      const res = await apiGetEventSearch(payload);
      this.searchOptions = {
        ...this.searchOptions,
        [payload.params.field]: res,
      };
    },
  },
  computed: {
    searchOptionSets() {
      return [
        {
          key: 'year',
          label: this.$t('EVENT_EVENT_DATE'),
          options: this.searchOptions[SEARCH_FIELD.publishDate]
        },
      ];
    },
  },
};
